import Grid from '@mui/material/Grid';
import { useRouter } from 'next/router';
import React from 'react';
import ErrorPage from '../components/General/ErrorPage';
import Head from '../components/Header/Head';
import Header from '../components/Header/Header';
import withApollo from '../lib/withApollo';

const ExitPage = () => {
  const router = useRouter();

  const { url } = router.query;

  return (
    <>
      <Head title="External Link | TravelFeed" noIndex noFollow />
      <Header active="page" />
      <Grid
        container
        spacing={0}
        alignItems="center"
        justifyContent="center"
        className="pt-4 pb-4"
      >
        {(url === 'undefined' && <ErrorPage statusCode={404} />) || (
          <ErrorPage statusCode="exit_url" url={url} />
        )}
      </Grid>
    </>
  );
};

export default withApollo(ExitPage);
